import type { IconData } from '@stacksjs/iconify-core'

export const exclamationTriangle: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M20.057 22H3.943a3.023 3.023 0 0 1-2.618-4.534L9.382 3.511a3.023 3.023 0 0 1 5.236 0l8.057 13.955A3.023 3.023 0 0 1 20.057 22\" opacity=\".5\"/><circle cx=\"12\" cy=\"17\" r=\"1\" fill=\"currentColor\"/><path fill=\"currentColor\" d=\"M12 14a1 1 0 0 1-1-1V9a1 1 0 0 1 2 0v4a1 1 0 0 1-1 1\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default exclamationTriangle
